<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader :title="id ? 'Update Tag' : 'Create Tag'" />
        <div>
          <md-button :to="{ name: 'Product Tags' }" class="md-primary">
            Back
          </md-button>
        </div>
      </div>

      <div>
        <form novalidate class="md-layout" @submit.prevent="validateUser">
          <md-field :class="getValidationClass('first_name')">
            <label>Titles</label>
            <md-input v-model="form.title" required></md-input>x
            <span class="md-error" v-if="!$v.form.title.required"
              >Title is required</span
            >
          </md-field>

          <md-field v-if="metadata">
            <label for="parent_id">Parent</label>
            <md-select v-model="form.parent_id" name="parent_id" id="parent_id">
              <md-option value="" disabled>Select Parent</md-option>
              <md-option
                v-for="(metadata, id) in metadata.parent_tags"
                :key="id"
                :value="id"
                >{{ metadata }}</md-option
              >
            </md-select>
          </md-field>

          <mdc-button :loading="loading">{{
            id ? "Update Tag" : "Create Tag"
          }}</mdc-button>
        </form>
      </div>
    </md-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("product");

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {},
    loading: false,
    metadata: null
  }),
  validations: {
    form: {
      title: {
        required
      }
    }
  },
  methods: {
    ...mapActions(["createTag", "updateTag", "getTagMetadata", "getTag"]),
    async validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = { ...this.form };

        try {
          this.loading = true;
          let call = this.id ? this.updateTag(data) : this.createTag(data);
          let msg = this.id ? "Tag Updated" : "Tag Created";
          await call;
          this.toast("success", msg);
          this.$router.push({ name: "Product Tags" });
          this.loading = false;
        } catch (err) {
          this.loading = false;
          this.toast("error", "Opps, Something went wrong ");
        }
      }
    },
    async getMeta() {
      this.fetching = true;
      const res = await this.getTagMetadata();
      this.fetching = false;
      this.metadata = res;
    }
  },
  mounted() {
    this.getMeta();
    if (this.id) {
      this.getTag(this.id).then((tag) => {
        this.form = {
          id: tag.id,
          title: tag.title,
          parent_id: tag.parent_id
        };
      });
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped lang="scss">
.feature-attributes {
  width: 100%;

  .wrapper {
    display: flex;
    align-items: center;
    gap: 20px;

    .val {
      flex: 1;
    }

    .attr {
      width: 25%;
    }
  }
}
</style>
